import React from 'react';
import logo from '../images/sendgrid-logo.png';
import Styles from './logo.module.scss';

const Logo = () => <img className={Styles.logo} src={logo} alt="SendGrid Logo" data-role="logo" />;

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.jsx